export const PERMISSIONS = {
  OVERVIEW: {
    VIEW: 'overview.view'
  },
  CALENDAR: {
    VIEW: 'calendar.view',
    CREATE: 'calendar.create',
    EDIT: 'calendar.edit',
    DELETE: 'calendar.delete'
  },
  APPOINTMENTS: {
    VIEW: 'appointments.view',
    VIEW_ALL: 'appointments.view_all',
    CREATE: 'appointments.create',
    EDIT: 'appointments.edit',
    DELETE: 'appointments.delete',
  },
  HISTORY: {
    VIEW: 'history.view'
  },
  EMPLOYEES: {
    VIEW: 'employees.view',
    CREATE: 'employees.create',
    EDIT: 'employees.edit',
    DELETE: 'employees.delete',
    EXPORT: 'employees.export'
  },
  CLIENTS: {
    VIEW: 'clients.view',
    CREATE: 'clients.create',
    EDIT: 'clients.edit',
    DELETE: 'clients.delete'
  },
  SETTINGS: {
    VIEW: 'settings.view',
    VIEW_ALL: 'settings.view_all',
    EDIT: 'settings.edit',
    VIEW_PRIVACY: 'settings.view_privacy'
  },
  LOCATIONS: {
    VIEW: 'locations.view',
    EDIT: 'locations.edit'
  },
  SUPPORT: {
    VIEW: 'support.view'
  }
};

export const ROLE_PERMISSIONS = {
  owner: [
    // Owner has all permissions
    ...Object.values(PERMISSIONS).flatMap(group => Object.values(group))
  ],
  manager: [
    // Manager permissions
    PERMISSIONS.OVERVIEW.VIEW,
    PERMISSIONS.HISTORY.VIEW,
    PERMISSIONS.CALENDAR.VIEW,
    PERMISSIONS.CALENDAR.CREATE,
    PERMISSIONS.CALENDAR.EDIT,
    PERMISSIONS.APPOINTMENTS.VIEW,
    PERMISSIONS.APPOINTMENTS.VIEW_ALL,
    PERMISSIONS.APPOINTMENTS.CREATE,
    PERMISSIONS.APPOINTMENTS.EDIT,
    PERMISSIONS.APPOINTMENTS.DELETE,
    PERMISSIONS.CLIENTS.VIEW,
    PERMISSIONS.CLIENTS.CREATE,
    PERMISSIONS.CLIENTS.EDIT,
    PERMISSIONS.SETTINGS.VIEW,
    PERMISSIONS.SETTINGS.VIEW_ALL,
    PERMISSIONS.SETTINGS.EDIT,
    PERMISSIONS.SETTINGS.VIEW_PRIVACY,
    PERMISSIONS.LOCATIONS.VIEW,
    PERMISSIONS.LOCATIONS.EDIT,
    PERMISSIONS.SUPPORT.VIEW
  ],
  employee: [
    // Basic employee permissions
    PERMISSIONS.OVERVIEW.VIEW,
    PERMISSIONS.HISTORY.VIEW,
    PERMISSIONS.CALENDAR.VIEW,
    PERMISSIONS.CALENDAR.CREATE,
    PERMISSIONS.APPOINTMENTS.VIEW,
    PERMISSIONS.APPOINTMENTS.CREATE,
    PERMISSIONS.APPOINTMENTS.EDIT,
    PERMISSIONS.CLIENTS.VIEW,
    PERMISSIONS.SETTINGS.VIEW,
    PERMISSIONS.EMPLOYEES.VIEW,
    PERMISSIONS.SUPPORT.VIEW
  ]
};

export const ROLE_KEYS = ['owner', 'manager', 'employee'];

export function mergeRolePermissions(stored) {
  const source = stored && typeof stored === 'object' ? stored : {};
  const merged = {};
  ROLE_KEYS.forEach((role) => {
    const defaultList = ROLE_PERMISSIONS[role] || [];
    const storedList = Array.isArray(source[role]) ? source[role] : [];
    merged[role] = [...new Set([...defaultList, ...storedList])];
  });
  return merged;
}